import React, {useEffect} from "react";
import {Link} from 'react-router-dom'

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';

import EmployerTabsRenderer from './EmployerTabsRendererComponent';
import * as ReduxDataStatus from '../../../utils/constants/ReduxDataStatus';
import {Loading} from '../../custom/LoadingComponent'



const MyEmployerManagement = (props) => {
    console.log('___MyEmployerManagement___');

    useEffect(() => {
        props.loadComponentData(props.myEmployerId);
    });


    if(props.dataStatus === ReduxDataStatus.IDLE || 
        props.dataStatus === ReduxDataStatus.LOADING) {
            return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                <Loading />
            </Box>
            </Container>
        );
    }
    else {

        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to='/home'>Acasa</Link>
                            <Typography color="text.primary">{props.employer.generalSection.employerName}</Typography>
                        </Breadcrumbs>
                    </Box>       

                    <Box>
                        <h3>Angajator: {props.employer.generalSection.employerName}</h3>
                    </Box>
                    <hr/>

                    <EmployerTabsRenderer 
                        employer={props.employer} 
                        worksites={props.worksites} 
                        patchEmployer={props.patchEmployer}
                        clients={props.clients}
                    />

                </Stack>

            </Box>
            </Container>
        );
    }

}


export default MyEmployerManagement